const STALE_DEPLOY_RELOAD_KEY = "dawn.staleDeployReloadAttempted";

function isStaleDeployChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const message = error.message.toLowerCase();
  return (
    message.includes("dynamically imported module") ||
    message.includes("importing a module script failed") ||
    message.includes("failed to load module script") ||
    (message.includes("mime type") && message.includes("text/html"))
  );
}

export function clearStaleDeployReloadAttempt(): void {
  sessionStorage.removeItem(STALE_DEPLOY_RELOAD_KEY);
}

export function tryRecoverFromStaleDeploy(error: unknown): boolean {
  if (!isStaleDeployChunkError(error)) {
    return false;
  }

  if (sessionStorage.getItem(STALE_DEPLOY_RELOAD_KEY) === "1") {
    return false;
  }

  sessionStorage.setItem(STALE_DEPLOY_RELOAD_KEY, "1");
  window.location.reload();
  return true;
}
